import { useElementContext } from "../../contexts";

const FeatureBanners = (props) => {
  const {
    CommonModule: { ContentCard },
  } = useElementContext();
  const { systemCode, innerElements, contentElementName, customStyleClasses } = props;
  return (
    <div className={`feature-banners px-4 ${systemCode} ${customStyleClasses}`}>
      {contentElementName && <h2 className="text-center">{contentElementName}</h2>}
      {innerElements.map((banner, i) => {
        return <ContentCard key={i} {...banner} />;
        // return <BandSlide key={slide.brandID} {...slide} />
      })}
    </div>
  );
};

export { FeatureBanners };
